import { createStore } from "vuex";

export default createStore({
  state: {
    loadingState: false,
  },
  getters: {
    getLoadingState(state) {
      return state.loadingState;
    },
  },
  mutations: {
    setLoadingState(state, payload) {
      state.loadingState = payload;
    },
  },
  actions: {},
  modules: {},
});
